import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const screenshots = [{
    src: 'https://cdn.magicpatterns.com/uploads/os2uVNgunXzJyNFfbbThqv/IMG_9472.jpg',
    alt: 'Testimonio: ame el librooo!!! este año quiero lograr lo mejor de mi'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/waFj62wcws3zvN66GHGJBU/IMG_8447.jpg',
    alt: 'Testimonio: Lo he descargado me emociona bastante poder empezar a leerlo'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7b6ZzdMW2ihJA81XTj46Zs/IMG_8499.jpg',
    alt: 'Testimonio: Un libro muy lindo, me encanta mucho la motivación y la profundidad'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/wg2TjwGYkQwFGCy3MmRWna/IMG_8376.jpg',
    alt: 'Testimonio: Apenas estoy comenzando a leer este libro y ya puedo decir que se siente diferente'
  }];
  return <section id="testimonios" className="py-24 bg-cream" data-id="element-306">
      <div className="max-w-7xl mx-auto px-6" data-id="element-307">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-308">
          <div className="inline-flex items-center space-x-1 mb-6" data-id="element-309">
            {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-rosegold" fill="currentColor" data-id="element-310" />)}
          </div>
          <h2 className="text-3xl md:text-4xl font-serif text-burgundy mb-4" data-id="element-311">
            Historias de Transformación
          </h2>
          <p className="text-lg text-taupe max-w-2xl mx-auto" data-id="element-312">
            Mujeres que decidieron dejar de buscar afuera y comenzaron a
            construir desde adentro.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-313">
          {screenshots.map((screenshot, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-white rounded-2xl shadow-sm overflow-hidden border border-rosegold/10" data-id="element-314">
              <img src={screenshot.src} alt={screenshot.alt} className="w-full h-auto" data-id="element-315" />
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-316">
          <p className="font-serif text-burgundy italic text-lg" data-id="element-317">
            "Testimonios reales de mujeres que ya comenzaron su transformación"
          </p>
        </motion.div>
      </div>
    </section>;
}